export default __webpack_public_path__ + "static/implementare-blockchain-58d27bab8c4165abab43625ebb58054f.jpg";